import { RouteConfig } from 'vue-router';
/* eslint-disable */
// @ts-ignore
import * as children from './pages/*/routes.ts';
/* eslint-enable */

export default {
  path: 'order',
  name: 'order',
  component: { template: '<router-view></router-view>' },
  children,
  redirect: {
    name: 'orders',
  },
} as RouteConfig;
